import * as React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@repo/ui-web';
import { tabStates } from '../../catalog/component-states';
import { StateToggle } from '../../components/StateToggle';

type TabState = (typeof tabStates)[number];

export function TabsShowcase() {
  const [tab, setTab] = React.useState<TabState>('account');

  return (
    <div className="space-y-4">
      <StateToggle options={tabStates} value={tab} onChange={setTab} label="Active tab" />
      <Tabs value={tab} onValueChange={(value) => setTab(value as TabState)}>
        <TabsList>
          <TabsTrigger value="account">Account</TabsTrigger>
          <TabsTrigger value="security">Security</TabsTrigger>
          <TabsTrigger value="billing">Billing</TabsTrigger>
        </TabsList>
        <TabsContent value="account">
          <p className="text-sm text-muted-foreground">Account profile details live here.</p>
        </TabsContent>
        <TabsContent value="security">
          <p className="text-sm text-muted-foreground">Security preferences and 2FA settings.</p>
        </TabsContent>
        <TabsContent value="billing">
          <p className="text-sm text-muted-foreground">Invoices and payment methods.</p>
        </TabsContent>
      </Tabs>
    </div>
  );
}
